import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Http from "../../../../Common/Http";

/* Dashboards a role can open. A switch is shown only when there is more than
   one to choose from. */
const DASHBOARDS = [
  { key: "sales", label: "Sales", icon: "fa-line-chart", to: "/dashboard", roles: ["admin"] },
  { key: "accounts", label: "Accounts", icon: "fa-calculator", to: "/accounts-dashboard", roles: ["admin"] },
];

/** Shortcut between the Sales and Accounts dashboards, for users who can see both. */
export const DashboardSwitcher = ({ current }) => {
  const [role, setRole] = useState(null);

  useEffect(() => {
    let active = true;
    Http.get("/staff-type-check")
      .then((res) => active && setRole(res.data))
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const options = DASHBOARDS.filter((dashboard) => dashboard.roles.includes(role));
  if (options.length < 2) return null;

  return (
    <nav className="dash-presets" aria-label="Switch dashboard">
      {options.map((dashboard) => (
        <Link
          key={dashboard.key}
          to={dashboard.to}
          className="dash-preset dash-switch"
          aria-current={dashboard.key === current ? "page" : undefined}
        >
          <i className={`fa ${dashboard.icon}`} aria-hidden="true" /> {dashboard.label}
        </Link>
      ))}
    </nav>
  );
};
